export const inboxItemStatus_Pending = 'inbox-item-status__pending';
export const inboxItemStatus_ActionNeeded = 'inbox-item-status__action-needed';
export const inboxItemStatus_Completed = 'inbox-item-status__completed';
export const inboxItemsStatus_CompletedAndViewed = 'inbox-item-status__completed-and-viewed';
const inboxItemStatuses = [inboxItemStatus_Pending, inboxItemStatus_ActionNeeded, inboxItemStatus_Completed, inboxItemsStatus_CompletedAndViewed];
//# sourceMappingURL=types.js.map